import { GraphUtils } from '@helpers/graph.helper';
import { Sensor } from './sensor';
import { Router } from '@angular/router';

export class PhSensor extends Sensor {
  public phChart: any;
  public temperatureChart: any;

  private phSensor: any[];
  private temperatureSensor: any[];

  constructor(router: Router, url: string, alerstActive: boolean) {
    super(router, url, alerstActive);
    this.phChart = null;
    this.temperatureChart = null;

    this.phSensor = [[], [], []];
    this.temperatureSensor = [[], [], []];
  }

  public hasPhSensor(pos: number): boolean {
    return this.phSensor[pos - 1].length > 0;
  }

  public getPhSensor(pos: number): any {
    const realPos: number = this.phSensor[pos - 1].length - 1;
    return this.phSensor[pos - 1][realPos][1] ?? null;
  }

  public hasTempSensor(pos: number): boolean {
    return this.temperatureSensor[pos - 1].length > 0;
  }

  public getTempSensor(pos: number): any {
    const realPos: number = this.temperatureSensor[pos - 1].length - 1;
    return this.temperatureSensor[pos - 1][realPos][1] ?? null;
  }

  public prepareData(): void {
    for (const element of this.data) {
      const date = new Date(element.date);
      this.phSensor[element.position].push([
        GraphUtils.getDateUtc(date),
        element.ph,
      ]);

      this.temperatureSensor[element.position].push([
        GraphUtils.getDateUtc(date),
        element.temperature,
      ]);
    }
  }

  public setCharts(): void {
    this.phChart = this.getConfigChar('phChart',
      this.getChartSeries('Ph', this.phSensor),
      this.getRanges('12_ph'),
      this.getLimits('12_ph')
    );
    this.temperatureChart = this.getConfigChar(
      'temperatureChart',
      this.getChartSeries('Pot', this.temperatureSensor),
      this.getRanges('12_temperature'),
      this.getLimits('12_temperature')
    );
  }

  public static getVariables(): any[] {
    return [
      { title: 'Ph', value: '12_ph' },
      { title: 'Temperatura', value: '12_temperature' }
    ];
  }
}